export const formatExtentions = (extentions: string[]): string => {
  return extentions.map(ext => ext.toUpperCase().split('/')[1]).join(', ');
};
